import { TBreadcrumb } from '../../redux/breadcrumbs';

export function createBreadcrumbsItems(breadcrumbs: TBreadcrumb[], projectId: string) {
  return breadcrumbs.map((item) => ({
    label: item.name,
    to: `/project/${projectId}/node/${item.id}`,
  }));
}
